import {
  SET_INITIALISED,
  SET_DATA,
  SET_BASEPATH,
  SET_ERROR,
  SET_COUNTRY,
  SET_DISTANCE,
  SET_QUERY,
  SET_LISTVIEW,
  SET_PLACE,
  SET_COUNTRIES,
  SET_DEALERS_DATA,
  SET_LAT_LNG,
  SET_ALL_DEALERS,
  SET_LOCATION_ERROR,
  SET_BIKE_TYPES,
  SET_SELECTED_BIKE_TYPES,
} from './types';

export const setInitialised = () => ({
  type: SET_INITIALISED,
});

export const setData = payload => ({
  type: SET_DATA,
  payload,
});

export const setBasepath = payload => ({
  type: SET_BASEPATH,
  payload,
});

export const setError = payload => ({
  type: SET_ERROR,
  payload,
});

export const setCountry = payload => ({
  type: SET_COUNTRY,
  payload,
});

export const setSelectedBikeTypes = payload => ({
  type: SET_SELECTED_BIKE_TYPES,
  payload,
});

export const setDistance = payload => ({
  type: SET_DISTANCE,
  payload,
});

export const setQuery = (query, method) => ({
  type: SET_QUERY,
  payload: {
    query,
    method,
  },
});

export const setListView = payload => ({
  type: SET_LISTVIEW,
  payload,
});

export const setPlace = payload => ({
  type: SET_PLACE,
  payload,
});

export const setCountries = payload => ({
  type: SET_COUNTRIES,
  payload,
});

export const setBikeTypes = payload => ({
  type: SET_BIKE_TYPES,
  payload,
});

export const setDealersData = (dealerData, options) => ({
  type: SET_DEALERS_DATA,
  payload: {
    dealerData,
    options,
  },
});

export const setLatLng = payload => ({
  type: SET_LAT_LNG,
  payload,
});

export const setAllDealers = (allDealerData, options) => ({
  type: SET_ALL_DEALERS,
  payload: {
    allDealerData,
    options,
  },
});

export const setLocationError = () => ({
  type: SET_LOCATION_ERROR,
});
